export const notifications = [

    {
        image: 'https://via.placeholder.com/256x256',
        title: "[TEST] Accepted re-booking",
        time: "4:10 PM",
        icon: "zmdi-thumb-up text-blue",
    }
];


// WEBPACK FOOTER //
// ./components/AppNotification/data.js